export enum ResourceType {
  Laundry = 'laundry',
  Gym = 'gym',
  MeetingRoom = 'meeting_room',
  Storage = 'storage',
  Other = 'other',
}
